var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreationCard4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666748,
    width: 40,
    height: 40,
    rx: 16,
    fill: "#EF4444"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.2196 11.0001C16.6027 11.0001 15.9052 11.0651 15.2388 11.2922C11.2217 12.6039 9.93016 16.894 11.0655 20.43L11.0703 20.4448L11.0755 20.4595C11.7011 22.2174 12.709 23.8127 14.0201 25.1249L14.0277 25.1324L14.0354 25.1398C15.9046 26.9323 17.9393 28.4953 20.1424 29.8515L20.6602 30.1703L21.1814 29.8573C23.3893 28.5315 25.4632 26.9254 27.3099 25.1474L27.3157 25.1419L27.3214 25.1362C28.6439 23.8215 29.6518 22.2144 30.2682 20.4549L30.2734 20.4402L30.2781 20.4253C31.3919 16.897 30.1069 12.6018 26.1174 11.3095C25.4643 11.0922 24.7903 11.0001 24.1315 11.0001C22.6495 11.0001 21.5526 11.6206 20.6671 12.2531C19.7887 11.6254 18.6843 11.0001 17.2196 11.0001Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreationCard4);
export default __webpack_public_path__ + "static/media/creation-card-4.3eda1919819db37217838197e2d6e16d.svg";
export { ForwardRef as ReactComponent };